import { Suspense } from "react"
import { createBrowserRouter, Navigate } from "react-router-dom"
import { Base } from './components/Base.tsx'
import { Fallback } from "./components/common/Fallback.tsx"

import {
    Homepage,
    DocumentView,
    ReportView,
    TasksView,
    InstantMoneyflowPage,
    MoneyFlowProvider,
    MoneyFlowGrid
} from "./lazyRouterComponents.tsx"
import ErrorBoundary from "antd/es/alert/ErrorBoundary"
import { LayoutProvider } from "./context/LayoutProvider.tsx"
import { MoneyflowLayoutModal } from "./modals/MoneyFlowLayoutModal/MoneyflowLayoutModal.tsx"
import { DiagramConfigProvider } from "./context/DiagramConfigProvider.tsx"
import { ReportRouterView } from "./components/ReportRouterView.tsx"
import { PublicMoneyflowPage } from "./components/Public/PublicMoneyFlowPage.tsx"
import { DiagramViewPortProvider } from "./components/sankey/DiagramViewPortProvider.tsx"
import { SharedLinksPage } from "./components/Public/SharedLinksPage.tsx"

const publicPageElement = <Suspense fallback={<Fallback />}>
    <ErrorBoundary>
        <DiagramConfigProvider>
            <MoneyFlowProvider>
                <PublicMoneyflowPage />
            </MoneyFlowProvider>
        </DiagramConfigProvider>
    </ErrorBoundary>
</Suspense>

export const router = createBrowserRouter([
    {
        path: '/',
        element: <Base />,
        children: [
            {
                path: '/',
                element: <ErrorBoundary>
                    <Suspense fallback={<Fallback />}>
                        <Homepage />
                    </Suspense>
                </ErrorBoundary>
            },
            {
                path: '/instant-moneyflow',
                element: <Suspense fallback={<Fallback />}>
                    <InstantMoneyflowPage />
                </Suspense>
            },
            {
                path: '/tasks',
                element: <Suspense fallback={<Fallback />}>
                    <TasksView />
                </Suspense>
            },
            {
                path: '/moneyflow',
                element: <Suspense fallback={<Fallback />}>
                    <DiagramViewPortProvider>
                        <DocumentView />
                    </DiagramViewPortProvider>
                </Suspense>,
                children: [
                    {
                        path: '/moneyflow/:documentId/:entityId',
                        element:
                            <Suspense fallback={<Fallback />}>
                                <ErrorBoundary>
                                    <DiagramConfigProvider>
                                        <MoneyFlowProvider>
                                            <LayoutProvider>
                                                <MoneyflowLayoutModal />
                                                <MoneyFlowGrid />
                                            </LayoutProvider>
                                        </MoneyFlowProvider>
                                    </DiagramConfigProvider>
                                </ErrorBoundary>
                            </Suspense>
                    },
                    {
                        path: '/moneyflow/:documentId',
                        element:
                            <Navigate replace to={`origin`} />
                    }
                ],
            },

            {
                path: '/report',
                element: <Suspense fallback={<Fallback />}>
                    <ReportRouterView />
                </Suspense>,
                children: [{
                    path: '/report/:reportId',
                    element: <ErrorBoundary>
                        <Suspense fallback={<Fallback />}>
                            <ReportView />
                        </Suspense>
                    </ErrorBoundary>
                }],
            },
        ],
    },
    {
        path: '/shared-links',
        element: <SharedLinksPage />
    },
    {
        path: '/share/:originalId/:name',
        element: publicPageElement
    },
    {
        path: '/share/:originalId/:address/:name',
        element: publicPageElement
    },
])
